exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* import styled from 'styled-components'; */\n.MoveToTopButton_buttonClass_2cFgx{\nposition: fixed;\nleft: 90%;\nbottom: 40px;\nfont-size: 3rem;\nz-index: 1000;\ncursor: pointer;\ncolor: #E87722;\n}\n.MoveToTopButton_buttonClass_2cFgx>button{\nborder-radius: 50%;\nborder: 2px solid gray;\nheight:50px;\nwidth: 50px;\n}\n.MoveToTopButton_buttonClass_2cFgx>button:hover{\nborder: none;\nbackground-color: #E87722;\n}\n.MoveToTopButton_buttonClass_2cFgx:hover{\ncolor: black;\n}\n", ""]);

// Exports
exports.locals = {
	"buttonClass": "MoveToTopButton_buttonClass_2cFgx"
};